import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sp-header__nav is-sp homepage" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sp-header__logo is-sp" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/public/home_page/img/logo.png" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/public/home_page/img/sp-logo.png",
      alt: "ロゴ"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "#feature",
  class: "link-color"
}, "BLOCKVROCKの特徴", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#voice",
  class: "link-color"
}, "ユーザーの声", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "#gallery",
  class: "link-color"
}, "ギャラリー", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<li class=\"sp-header__menu-item\"><a href=\"/login\" target=\"_blank\" class=\"link-color\">ログイン</a></li><li class=\"header__menu-item sp-header__menu-item--cta\"><a class=\"sp-cta-min\" href=\"./account_register\" target=\"_blank\">今すぐ体験</a></li><li class=\"header__menu-item sp-header__menu-item--cta\"><a class=\"contact-min\" href=\"https://levelenter.com/contact/\" target=\"_blank\"><span>企業様・教育機関様へ</span>導入に関するお問い合わせ</a></li>", 3)


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneMenuSection',
  setup(__props) {

const closeMenu = () => {
  document.querySelector('.sp-header__nav').classList.remove('is-active');
  document.querySelector("header").classList.remove("is-open");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", { class: "header__menu" }, [
      _createElementVNode("li", {
        class: "sp-header__menu-item",
        onClick: closeMenu
      }, _hoisted_4),
      _createElementVNode("li", {
        class: "sp-header__menu-item",
        onClick: closeMenu
      }, _hoisted_6),
      _createElementVNode("li", {
        class: "sp-header__menu-item",
        onClick: closeMenu
      }, _hoisted_8),
      _hoisted_9
    ])
  ]))
}
}

})